import styled from 'styled-components';
import {ButtonBase} from '../../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';

export const FilterList = styled.ul(
  props => `
  display: flex;
  align-items: center;
  position: relative;
  position: sticky;
  // top: 14.8rem;
  top:14.9rem;
  padding: 2rem 0;
  // border-radius:1.2rem;
  // padding: ${props.theme.spacing.custom(24)} 0;
  z-index: 3; 
  >li{
    position: relative;
    border: 0.1rem solid ${props.theme.colors.ash.dark};
    background-color: #ffffff;
    padding: ${props.theme.spacing.custom(8)} ${props.theme.spacing.custom(
      32,
    )} ${props.theme.spacing.custom(8)} ${props.theme.spacing.custom(8)};
    border-radius: ${props.theme.misc.borderRadius.xlarge};
    margin-right: ${props.theme.spacing.custom(12)};
    color: ${props.theme.colors.goBrandBlue.dark};
    font-size: ${props.theme.font.custom(16)};
    cursor: pointer;
    &.active{
      background: ${props.theme.colors.goBrandBlue.dark};
      color: ${props.theme.colors.goWhite.base};
      >span{
        &:before{
            border: solid #ffffff;
            border-width: 0 0.2rem 0.2rem 0;
        }
      }
      >svg{
        fill: white;
      }
    }
    >span{
      color: inherit;
      &.showList{
        &:before{
          transform: rotate(229deg);
          top: 1.6rem;
        }
      }
      &:before{
        border: solid #1958B6;
        border-width: 0 0.2rem 0.2rem 0;
        display: inline-block;
        padding: 0.3rem;
        transform: rotate(45deg);
        position: absolute;
        right: 1.2rem;
        top: 1.2rem;
        content: "";
        transition: all 0.5s ease;
        &.active{
          border: solid #ffffff;
        }
      }
    }

  }
`,
);

export const CheckBox = styled.input.attrs({type: 'checkbox'})(
  props => `
  height: 1.8rem;
  width: 1.8rem;
  margin-right: ${props.theme.spacing.base};
  &::checked {
    border: 0.1rem solid ${props.theme.colors.goBrandBlue.base};
    background-color: ${props.theme.colors.goBrandBlue.base};
  }
`,
);

export const SubFilterItem = styled.label(
  props => `
  display: flex;
  align-items: center;
  margin-bottom: ${props.theme.spacing.custom(12)};
`,
);

export const TextStyledSpan = styled.label(
  props => `
  font-size: ${props.theme.font.custom(14)};
  color: ${props.theme.colors.downriver.base};
`,
);

export const FilterByText = styled.p(
  props => `
  font-weight: 600;
  color: ${props.theme.colors.downriver.dark};
  font-size: ${props.theme.font.custom(16)};
  margin-right: ${props.theme.spacing.custom(12)};
`,
);

export const FilterDropdown = styled.div(
  props => `
  width: 315px;
  position: absolute;
  top: 4.5rem;
  left: 0;
  background: ${props.theme.colors.goWhite.base};
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.12);
  border-radius: ${props.theme.misc.borderRadius.xlarge};
  z-index: 3;
`,
);

export const FilterDropdownTop = styled.div(
  props => `
  padding:0px;
  border-bottom: 1px solid #E1E7EE;
`,
);

export const FilterDropdownBottom = styled.div(
  props => `
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${props.theme.spacing.custom(12)} ${props.theme.spacing.custom(
    16,
  )} ${props.theme.spacing.custom(12)} ${props.theme.spacing.xxlarge};
`,
);

export const FilterApplyBtn = styled(ButtonBase)(
  props => `
  width: 16rem;
  text-transform: capitalize;
  border-radius: ${props.theme.misc.borderRadius.xlarge};
  padding: ${props.theme.spacing.base} ${props.theme.spacing.custom(16)};
`,
);
